var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlabama(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.911,220.097l98.833-12.04c0,0-3.764-10.537-5.519-21.573c-0.152-0.954-0.296-1.897-0.429-2.83 c-1.436-9.861-1.928-18.446-0.326-23.257c1.759-5.268,4.767-6.522,3.513-8.781c-1.254-2.256-9.278-12.791-11.538-18.81 c-2.258-6.021-16.807-63.964-18.562-67.977c-1.757-4.015-6.772-15.302-6.772-17.058c0-1.756-1.756-13.796-1.756-13.796 l-24.137,2.101l-67.085,5.842l-0.935,1.278l-0.355,18.606l-2.277,119.174l8.556,64.816l8.723,1.896l6.019-13.549h4.014l6.523,13.549 l-5.518,6.52l5.518-1.505l12.041-5.015l2.007-13.549l-10.539-8.527V220.097z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlabama);
export default __webpack_public_path__ + "static/media/alabama.7309d5381a1018e6056e62a1729cec02.svg";
export { ForwardRef as ReactComponent };